import {
	withDestroyEndpoint,
	withIndexEndpoint,
	withOptionsEndpoint,
	withShowEndpoint,
	withStoreEndpoint,
	withUpdateEndpoint,
} from "@dgs/core";
import { CategoryIndexResource, CategorySaveRequest, CategoryUpdateResource } from "../types";

const baseKey = "categories";

export const categoryService = {
	...withShowEndpoint<CategoryUpdateResource>([baseKey]),
	...withIndexEndpoint<CategoryIndexResource>([baseKey]),
	...withStoreEndpoint<CategorySaveRequest>([baseKey]),
	...withUpdateEndpoint<CategorySaveRequest>([baseKey]),
	...withOptionsEndpoint<CategoryIndexResource>([baseKey]),
	...withDestroyEndpoint([baseKey]),
};
